import * as React from "react"
import {useEffect} from "react"
import {Box, Skeleton} from "@mui/material";
import { ButtonIconSeeker } from "@ui-seeker/core"
import { AppTableSeeker } from "@components"
import {scrollToComponent, formatDate, FORMAT_DATE_BACK} from "@ui-seeker/utils";

import {GROUPED_BY, SHARE_OF_SEARCH_ROUTES, ACTUAL_PERIODS} from "@constants";
import {useShareUrl} from "@hooks";
import {keywordColumn} from "./columns";
import { KEYWORD_TYPE } from "../@constants";
import {useShareOfSearchKpiDetails} from "../@hooks";
import {shareOfSearchKpiDetailsFilters, shareOfSearchKpiEvolutionFilters, shareOfSearchKpiEvolutionDatePeriod, shareOfSearchKpiEvolutionKeywordsOptions} from "../@signals";
import {retailerWithCountryColumn, retailerWithoutCountryColumn, scoreColumn, countryColumn} from "../../../../@components/KpiTable/columns";


export default function ShareOfSearchKpiTableDetails() {
	const { buildShareParams } = useShareUrl()
	const {detailsData, detailsAggregation, isLoadingDetails, detailsIsGenericType} = useShareOfSearchKpiDetails()

	useEffect(() => {
		if (detailsData.length)
			scrollToComponent('details-table')
	}, [detailsData.length]);

	if (isLoadingDetails)
		return <Skeleton variant="rectangular" height={500} />
	if (detailsData.length === 0)
		return <></>

	const columns = [
		...(detailsAggregation.includes(GROUPED_BY.COUNTRY) ? countryColumn() : []),
		...(detailsAggregation.includes(GROUPED_BY.RETAILER) && detailsAggregation.includes(GROUPED_BY.COUNTRY) ? [retailerWithCountryColumn()] : []),
		...(detailsAggregation.includes(GROUPED_BY.RETAILER) && !detailsAggregation.includes(GROUPED_BY.COUNTRY) ? retailerWithoutCountryColumn() : []),
		keywordColumn()
	]

	if (detailsIsGenericType) {
		columns.push(
			scoreColumn(
				'Generic',
				'Generic',
				false,
				[],
				[{
					icon: 'memo-circle-info',
					label: 'Go to details',
					buildUrl: (dataRow) => `${SHARE_OF_SEARCH_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
						keyword: [dataRow[`keywordID`]],
						...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country.toLowerCase()]},
						...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
					})}&launch=true`
				}, {
					icon: 'chart-line',
					label: 'Show KPI Evolution',
					onClick: (dataRow) => {
						shareOfSearchKpiEvolutionKeywordsOptions.value = [{label: dataRow['keyword'], value: dataRow[`keywordID`]}]
						shareOfSearchKpiEvolutionFilters.value = {
							keywordType: KEYWORD_TYPE.KEYWORD,
							['keyword']: [dataRow[`keywordID`]],
							id_keyword_type: [dataRow[`GenericID`]],
							startDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][0], {format: FORMAT_DATE_BACK}),
							endDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][1], {format: FORMAT_DATE_BACK}),
							...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country]},
							...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
						}

					}
				}],
				true
			),
			scoreColumn(
				'Generic Organic',
				'Generic Organic',
				false,
				[],
				[{
					icon: 'memo-circle-info',
					label: 'Go to details',
					buildUrl: (dataRow) => `${SHARE_OF_SEARCH_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
						keyword: [dataRow[`keywordID`]],
						...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country.toLowerCase()]},
						...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
					})}&launch=true`
				}, {
					icon: 'chart-line',
					label: 'Show KPI Evolution',
					onClick: (dataRow) => {
						shareOfSearchKpiEvolutionKeywordsOptions.value = [{label: dataRow['keyword'], value: dataRow[`keywordID`]}]
						shareOfSearchKpiEvolutionFilters.value = {
							keywordType: KEYWORD_TYPE.KEYWORD,
							['keyword']: [dataRow[`keywordID`]],
							id_keyword_type: [dataRow[`Generic OrganicID`]],
							startDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][0], {format: FORMAT_DATE_BACK}),
							endDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][1], {format: FORMAT_DATE_BACK}),
							...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country]},
							...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
						}

					}
				}],
				true
			),
			scoreColumn(
				'Generic Sponsored',
				'Generic Sponsored',
				false,
				[],
				[{
					icon: 'memo-circle-info',
					label: 'Go to details',
					buildUrl: (dataRow) => `${SHARE_OF_SEARCH_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
						keyword: [dataRow[`keywordID`]],
						...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country.toLowerCase()]},
						...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
					})}&launch=true`
				}, {
					icon: 'chart-line',
					label: 'Show KPI Evolution',
					onClick: (dataRow) => {
						shareOfSearchKpiEvolutionKeywordsOptions.value = [{label: dataRow['keyword'], value: dataRow[`keywordID`]}]
						shareOfSearchKpiEvolutionFilters.value = {
							keywordType: KEYWORD_TYPE.KEYWORD,
							['keyword']: [dataRow[`keywordID`]],
							id_keyword_type: [dataRow[`Generic SponsoredID`]],
							startDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][0], {format: FORMAT_DATE_BACK}),
							endDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][1], {format: FORMAT_DATE_BACK}),
							...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country]},
							...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
						}

					}
				}],
				true
			)
		)
	} else {
		columns.push(
			scoreColumn(
				'score',
				'Score',
				false,
				[],
				[{
					icon: 'memo-circle-info',
					label: 'Go to details',
					buildUrl: (dataRow) => `${SHARE_OF_SEARCH_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
						keyword: [dataRow[`keywordID`]],
						...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country.toLowerCase()]},
						...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
					})}&launch=true`
				}, {
					icon: 'chart-line',
					label: 'Show KPI Evolution',
					onClick: (dataRow) => {
						shareOfSearchKpiEvolutionKeywordsOptions.value = [{label: dataRow['keyword'], value: dataRow[`keywordID`]}]
						shareOfSearchKpiEvolutionFilters.value = {
							keywordType: KEYWORD_TYPE.KEYWORD,
							['keyword']: [dataRow[`keywordID`]],
							startDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][0], {format: FORMAT_DATE_BACK}),
							endDate: formatDate(ACTUAL_PERIODS[shareOfSearchKpiEvolutionDatePeriod.value][1], {format: FORMAT_DATE_BACK}),
							...detailsAggregation.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country]},
							...detailsAggregation.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
						}

					}
				}],
				true
			)
		)
	}

	return <Box>
		<AppTableSeeker
			id="details-table"
			data={detailsData}
			columns={columns}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={() => shareOfSearchKpiDetailsFilters.value = {}}
				/>
			}}
		/>
	</Box>
}